module.exports = __webpack_public_path__ + "assets/img/plain.956930ec.png";